import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=0a7633f3&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=ts"
export * from "./BlogPage.vue?vue&type=script&lang=ts"
import style0 from "./BlogPage.vue?vue&type=style&index=0&id=0a7633f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7633f3",
  null
  
)

export default component.exports